import { useState } from "react";
import { useDispatch } from "react-redux";

import { UploadFileOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import useEditing from "pages/Som/SomItem/hooks/useEditing";
import { uploadSomOfferJusts } from "slices/som/services/uploadSomOfferJusts";

import { JustificationsList } from "../JustificationsList/JustificationsList";
import styles from "./JustificationsDetails.module.css";

export const JustificationsDetails = ({ rowObj }) => {
	const dispatch = useDispatch();
	const { isEditingAllowed } = useEditing();

	const [isDraggingFile, setDraggingFile] = useState(false);

	const containerClassName = isDraggingFile ? `${styles.container} ${styles.drag}` : styles.container;

	const handleStartDragFile = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDraggingFile(true);
	};

	const handleEndDragFile = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDraggingFile(false);
	};

	const dispatchUploadJusts = (files) => {
		dispatch(uploadSomOfferJusts({ files, offerId: rowObj.id }));
	};

	const handleDropFile = (e) => {
		handleEndDragFile(e);
		dispatchUploadJusts(e.dataTransfer.files);
	};

	const UploadInput = () => (
		<input
			multiple
			type="file"
			onChange={(e) => {
				dispatchUploadJusts(e.target.files);
			}}
		/>
	);

	return (
		<>
			<tr
				className={styles.row}
				onDragEnter={handleStartDragFile}
				onDragOver={handleStartDragFile}
				onDragLeave={handleEndDragFile}
				onDrop={handleDropFile}
			>
				<td colSpan={8} className={styles.column}>
					{isEditingAllowed(rowObj, "EDIT") === true && (
						<div className={containerClassName}>
							<div className={styles.uploadIcon}>
								<IconButton
									component="label"
									size="small"
									sx={{
										color: "var(--import-button-color)",
									}}
								>
									<UploadFileOutlined />
									<UploadInput />
								</IconButton>
							</div>
							<div className={styles.uploadText}>
								Для загрузки{" "}
								<label>
									укажите файлы
									<UploadInput />
								</label>{" "}
								обосновывающих документов или перенесите файлы в эту область
							</div>
							<div className={styles.uploadLimit}>При передаче архива используйте только формат .ZIP (max. 81MB)</div>
							<JustificationsList justs={rowObj.just_links} rowObj={rowObj} />
						</div>
					)}
					{isEditingAllowed(rowObj, "EDIT") !== true && <JustificationsList justs={rowObj.just_links} />}
				</td>
			</tr>
		</>
	);
};
